import { Component, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';
import { OptionItem } from 'morgana';

@Component({
	selector: 'pms-individual-benefits-form',
	templateUrl: './individual-benefits-form.component.html',
	styles: [],
	standalone: false,
})
export class IndividualBenefitsFormComponent implements OnInit {

	componentForm: UntypedFormGroup;
	frameOptions: OptionItem[] = [
		{label: 'Yes', value: true},
		{label: 'No', value: false},
	];
	lensOptions: OptionItem[] = [
		{label: 'Yes', value: true},
		{label: 'No', value: false},
	];
	contactLensOptions: OptionItem[] = [
		{label: 'Yes', value: true},
		{label: 'No', value: false},
	];

	dateFormat = DATE_FORMATS.MM_DD_YYYY;

	constructor(
		public controlContainer: ControlContainer,
	) {
	}

	ngOnInit() {
		this.componentForm = this.controlContainer.control as UntypedFormGroup;
	}

}
